export default __webpack_public_path__ + "static/media/exclusive3.d4286390.png";